import {Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromStore from '../_store';
import {Store} from '@ngrx/store';
import * as _ from 'lodash';
import {filter, take} from 'rxjs/operators';

@Injectable()
export class FrequentFlyerIndraResolver implements Resolve<any> {

	private sub$: Subscription;

	constructor(
		private store: Store<fromStore.State>
	) { }

	resolve(): Observable<any> {
		this.init();
		this.sub$.unsubscribe();
		return this.store.select(
			fromStore.getSelectedFrequentFlyerPrograms
		).pipe(
			filter(data => !_.isNil(data)),
			take(1)
		);
	}

	private init() {
		this.sub$ = this.store.select(
			fromStore.getSelectedFrequentFlyerPrograms
		).subscribe(data => {
			if (_.isNil(data)) {
				this.store.dispatch(new fromStore.LoadFrequentFlyerPrograms());
			}
		});
	}

}
